/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-03-03 13:43:35
 * @LastEditors: linwc
 * @LastEditTime: 2025-03-03 14:24:14
 * @FilePath: /ryGitLab/lysorasurvey/src/api/common.js
 */
import { requestHttp } from '@/utils';

const SERVER = '';
const commonApi = {
  teamMember: `${SERVER}/team_member/self/get`,
  getRoleUser: `${SERVER}/assign-user/list`
};

export const teamMember = (data = {}) => {
  return requestHttp({
    api: commonApi.teamMember,
    method: 'GET',
    module: 'um',
    querys: data
  });
};

/**
 * 获取用户组权限
 *
 * TODO: 服务端接口用户组参数字段为 `userGroupId`，但是早期前端传递的参数字段为 `userGroupIdProd` 和 `userGroupIdTest`，这里需要注意
 *
 * FIXME: 目前该 API 方法内部逻辑区分国内和海外环境，主要因为国内和海外环境的域名不一致做区分判断，但是这种判断方式不够严谨，后续需要优化
 *
 * @param { object } data 请求参数
 * @param { number } data.userGroupId 用户组ID，服务端传参字段
 * @param { number } [data.userGroupIdProd] 生产环境用户组ID
 * @param { number } [data.userGroupIdTest] 测试环境用户组ID
 * @returns { Promise }
 */
export const getRoleUserApi = (data = {}) => {
  if (process.env.VUE_APP_CLOUD_DEFAULT_LANGUAGE === 'en') {
    return requestHttp({
      api: commonApi.getRoleUser,
      method: 'POST',
      module: 'um',
      params: {
        /**
         * FIXME: 目前判断开发环境或测试环境的逻辑不够严谨，后续需要优化
         */
        userGroupId:
          window.location.origin.indexOf('lysoratech.rj.link') >= 0 ||
          window.location.origin.indexOf('127.0.0.1') >= 0 ||
          window.location.origin.indexOf('localhost') >= 0
            ? 6
            : 11,
        ...data
      }
    });
  } else {
    return requestHttp({
      api: commonApi.getRoleUser,
      method: 'POST',
      module: 'um',
      params: {
        userGroupId:
          window.location.origin.indexOf('cloud-us.lysoratech.com') >= 0 ? data.userGroupIdProd : data.userGroupIdTest,
        ...data
      }
    });
  }
};
